import { call, put, takeLatest, select } from "redux-saga/effects";

import { getCoupon, validateCoupon } from "./CartApis";
import * as ACTIONS from "./CartActions";
import * as TYPES from "./CartTypes";
import { setErrorMessage } from "../Error/ErrorAction";
import {
  ALL_DELIVERY_TYPES,
  COUPONS,
  CURRENCY,
  ORDER_TYPES,
} from "../../utils/Constants";

// Replace with your sagas
export function* sagasCouponRequest({ payload }) {
  try {
    const hotelKey = payload;
    if (!hotelKey) {
      throw new Error("Something went wrong with the hotel key");
    }

    const response = yield call(getCoupon, hotelKey);
    if (!response?.data?.data) {
      throw new Error("Something went wrong with the response");
    }

    yield put(ACTIONS.getCouponReceive(response.data.data));
  } catch (err) {
    yield put(ACTIONS.getCouponReceive([]));
  }
}

export function* sagasValidateCoupon({ payload }) {
  yield put(ACTIONS.IsValidating(true)); // Start the validation process
  try {
    const { customerId, code, store_id, time } = payload;

    // Make the API call to validate the coupon
    const response = yield call(
      validateCoupon,
      customerId,
      code,
      store_id,
      time
    );
    
    // Set the validated coupon data regardless of validation result
    yield put(ACTIONS.setValidatedCoupon(response?.data?.data));

    const coupon = response?.data?.data;
    
    // If API response status is false, set validation to false and return
    if (response?.data?.status !== true) {
      yield put(ACTIONS.setCouponValidationResult(false));
      yield put(
        setErrorMessage({
          message: response?.data?.message || "Invalid Coupon",
          showAs: "dialog",
        })
      );
      return;
    }
    
    if (coupon?.id) {
      const { priceSummary, checkoutDetails, data } = yield select(
        (state) => state.cart
      );

      const checkItemDiscountApplicability = (coupon) => {
        if (
          coupon?.rules?.type === COUPONS.ITEM_DISCOUNT &&
          coupon?.items &&
          coupon?.items?.length > 0
        ) {
          const applicableItems = JSON.parse(coupon?.items) || [];
          const validItemsInCart = data?.filter((item) =>
            applicableItems.includes(item.itemId)
          );

          if (
            applicableItems?.length === 1 &&
            coupon?.result?.DISCOUNT === 100 &&
            validItemsInCart?.length === 1 &&
            validItemsInCart[0]?.count > 1
          ) {
            return true;
          } else {
            return true;
          }
        } else return true;
      };

      // Check coupon applicability
      if (checkItemDiscountApplicability(coupon)) {
        let applicableItems = [];
        let validItemsInCart = [];
        
        if (coupon?.rules?.type === "BUY_ONE_GET_ONE_FREE") {
          const applicableItems = (coupon?.rules?.APPLICABLE_ITEMS || []).map(item => item.id); // Extract IDs into array
          
          validItemsInCart = data?.filter((item) =>
            applicableItems.includes(item.itemId)
          );
        
    
        }
        else {
          applicableItems = JSON.parse(coupon?.items) || [];
          validItemsInCart = data?.filter((item) =>
            applicableItems.includes(item.itemId)
          );
        }
        
        // Check if required products are in cart based on coupon type
        let shouldShowError = false;
        
        if (coupon?.rules?.type === "ITEM_DISCOUNT") {
          shouldShowError = validItemsInCart?.length === 0 && coupon?.result?.DISCOUNT < 100;
        } else if (coupon?.rules?.type === "BUY_ONE_GET_ONE_FREE") {
          shouldShowError = validItemsInCart?.length === 0;
        }
        // Skip check for CART_DISCOUNT and FREE_DELIVERY types
        
        if (shouldShowError) {
          yield put(
            setErrorMessage({
              message: "The required items are not in cart",
              showAs: "dialog",
            })
          );
          yield put(ACTIONS.setCouponValidationResult(false));
          return; // Prevent coupon from being applied
        }
        
        if (
          coupon?.rules?.APPLICABLE_FOR === checkoutDetails?.orderType ||
          coupon?.rules?.APPLICABLE_FOR === ALL_DELIVERY_TYPES
        ) {
     
          if (
            Number(priceSummary?.subTotal) >=
            Number(coupon?.rules?.MIN_ORDER_VALUE) &&   Number(priceSummary?.subTotal) <=
            Number(coupon?.rules?.MAX_ORDER_VALUE)
          ) {
            if (payload?.isNewCoupon) {
              // console.log("workingggggggggggg");
              yield put(ACTIONS.getCouponReceive([coupon]));
              yield put(ACTIONS.setCouponValidationResult(true)); // Set to true only when all validations pass
            } else {
              // For existing coupons, still set validation result to true
              yield put(ACTIONS.setCouponValidationResult(true));
            }
            return; // Successfully validated and applied
          } else {
            // Check if order value is too low or too high
            if (Number(priceSummary?.subTotal) < Number(coupon?.rules?.MIN_ORDER_VALUE)) {
              yield put(
                setErrorMessage({
                  message: `Order value should be more than ${CURRENCY.SIGN}${coupon?.rules?.MIN_ORDER_VALUE}`,
                  showAs: "dialog",
                })
              );
            } else if (Number(priceSummary?.subTotal) > Number(coupon?.rules?.MAX_ORDER_VALUE)) {
              yield put(
                setErrorMessage({
                  message: `Order value should be less than ${CURRENCY.SIGN}${coupon?.rules?.MAX_ORDER_VALUE}`,
                  showAs: "dialog",
                })
              );
            }
            yield put(ACTIONS.setCouponValidationResult(false));
            return; // Prevent coupon from being applied
          }
        } else {
          yield put(
            setErrorMessage({
              message: `Only applicable for ${
                coupon?.rules?.APPLICABLE_FOR === ORDER_TYPES.DELIVERY
                  ? "Delivery"
                  : "Pickup"
              }`,
              showAs: "dialog",
            })
          );
          
          yield put(ACTIONS.setCouponValidationResult(false));
          return; // Prevent coupon from being applied
        }
      } else {
        yield put(
          setErrorMessage({
            message: response?.data?.message || "Invalid Coupon",
            showAs: "dialog",
          })
        );
        yield put(ACTIONS.setCouponValidationResult(false));
        return; // Prevent coupon from being applied
      }
    } else {
      yield put(
        setErrorMessage({
          message: response?.data?.message || "Invalid Coupon",
          showAs: "dialog",
        })
      );
      yield put(ACTIONS.setCouponValidationResult(false));
      return; // Prevent coupon from being applied
    }
  } catch (err) {
  
    yield put(ACTIONS.setCouponValidationResult(false));
    yield put(
      setErrorMessage({
        message: "Something went wrong",
        showAs: "dialog",
      })
    );
  } finally {
    // Always reset isValidating state at the end
    yield put(ACTIONS.IsValidating(false));
  }
}
// export function* sagasValidateCoupon({ state, payload }) {
//   try {
//     const { hotelId, code } = payload;
//     if (!hotelId) {
//       throw new Error("Something went wrong with the hotel id");
//     }

//     const response = yield call(validateCoupon, hotelId, code);
//     const coupon = response?.data?.data;
//     //checking coupon is applicabile
//     if (coupon?.id) {
//       const { priceSummary, checkoutDetails, data } = yield select(
//         (state) => state.cart
//       );

//       //   const getPrice = (coupon) => {
//       //     if (coupon?.rules?.type === COUPONS.ITEM_DISCOUNT) {
//       //       const applicableItems = JSON.parse(coupon?.items) || [];
//       //       const validItemsInCart = data?.filter((item) =>
//       //         applicableItems.includes(item.itemId)
//       //       );
//       //       let itemTotal = 0;
//       //       validItemsInCart.forEach((item) => {
//       //         const itemPrice = item?.count * item?.sale_price;
//       //         itemTotal = itemTotal + itemPrice;
//       //       });
//       //       return Number(itemTotal);
//       //     } else {
//       //       return Number(priceSummary?.subTotal);
//       //     }
//       //   };

//       const checkItemDiscountApplicability = (coupon) => {
//         if (
//           coupon?.rules?.type === COUPONS.ITEM_DISCOUNT &&
//           coupon?.items &&
//           coupon?.items?.length > 2
//         ) {
//           const applicableItems = JSON.parse(coupon?.items) || [];
//           const validItemsInCart = data?.filter((item) =>
//             applicableItems.includes(item.itemId)
//           );
//           // This condition for: 100% discount item can have only 1 quantity of that particular item
//           if (
//             applicableItems?.length === 1 &&
//             coupon?.result?.DISCOUNT === 100 &&
//             validItemsInCart?.length === 1 &&
//             validItemsInCart[0]?.count > 1
//           ) {
//             return false;
//           } else return !!validItemsInCart.length;
//         } else return true;
//       };

//       //check if it is exposed coupon or not
//       if (checkItemDiscountApplicability(coupon)) {
//         // check greater than subtotal
//         if (
//           coupon?.rules?.APPLICABLE_FOR === checkoutDetails?.orderType ||
//           coupon?.rules?.APPLICABLE_FOR === ALL_DELIVERY_TYPES
//         ) {
//           //   check delivery type
//           if (
//             Number(priceSummary?.subTotal) >
//             Number(coupon?.rules?.MIN_ORDER_VALUE)
//           ) {
//             //if coupon is applicable
//             yield put(ACTIONS.selectCoupon(coupon));
//           } else {
//             //if coupon is not applicable
//             yield put(
//               setErrorMessage({
//                 message: `Order value should be more than ${CURRENCY.SIGN}${coupon?.rules?.MIN_ORDER_VALUE}`,
//                 showAs: "dialog",
//               })
//             );
//           }
//         } else {
//           //if coupon is not applicable
//           yield put(
//             setErrorMessage({
//               message: `Only applicable for ${
//                 coupon?.rules?.APPLICABLE_FOR === COUPONS.CART_DISCOUNT
//                   ? "cart discount"
//                   : "item discount"
//               }`,
//               showAs: "dialog",
//             })
//           );
//         }
//       } else {
//         //if coupon is not applicable
//         yield put(
//           setErrorMessage({
//             message: `Invalid coupon`,
//             showAs: "dialog",
//           })
//         );
//       }

//       //   if (
//       //     Number(priceSummary?.subTotal) >
//       //       Number(coupon?.rules?.MIN_ORDER_VALUE) &&
//       //     (coupon?.rules?.APPLICABLE_FOR === checkoutDetails?.orderType ||
//       //       coupon?.rules?.APPLICABLE_FOR === ALL_DELIVERY_TYPES)
//       //   ) {
//       //     //if coupon is applicable
//       //     yield put(ACTIONS.selectCoupon(coupon));
//       //   } else {
//       //     //if coupon is not applicable
//       //     yield put(
//       //       setErrorMessage({
//       //         message: `Minimum order value is atleast $${coupon?.rules?.MIN_ORDER_VALUE}`,
//       //         showAs: "dialog",
//       //       })
//       //     );
//       //   }
//     } else {
//       yield put(
//         setErrorMessage({
//           message: "Invalid coupon",
//           showAs: "dialog",
//         })
//       );
//     }
//   } catch (err) {
//     yield put(
//       setErrorMessage({
//         message: "Something went wrong",
//         showAs: "dialog",
//       })
//     );
//   }
// }

export function* CartSaga() {
  yield takeLatest(TYPES.GET_COUPON_REQUEST, sagasCouponRequest);
}

export function* VerifyCouponSaga() {
  yield takeLatest(TYPES.VALIDATE_COUPON, sagasValidateCoupon);
}
